export const guarantees = [
  {
    icon: "ri-eye-off-line",
    title: "匿名投稿",
    desc: "投稿不需要注册账号，也不强制填写姓名与联系方式。你可以只留下想说的那部分内容，其余一概不填。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "隐私保护",
    desc: "我们只保留阅读与核实所需的最少信息，投稿正文中的电话、住址、工号等可识别字段会被优先处理。",
  },
  {
    icon: "ri-lock-password-line",
    title: "保密机制",
    desc: "每条信息按保密流程分级处理，接触范围按需授权。不公开发布可定位到个人的原始材料。",
  },
];

export const steps = [
  {
    step: "01",
    icon: "ri-shield-check-line",
    title: "匿名进入通道",
    desc: "通过本站投稿入口提交，不需要账号，不会展示你的网络来源信息。",
  },
  {
    step: "02",
    icon: "ri-file-shred-line",
    title: "自动脱敏处理",
    desc: "系统与人工双重检查，对正文中的身份线索做模糊化，避免在流转中被反查。",
  },
  {
    step: "03",
    icon: "ri-git-branch-line",
    title: "分级保密流转",
    desc: "内容按涉密程度分级，仅向处理该条信息所需的必要环节开放，全程留痕可追溯。",
  },
  {
    step: "04",
    icon: "ri-message-2-line",
    title: "可选匿名回执",
    desc: "若你留下了回执代号，我们只通过该代号与你联系，不索取任何额外身份信息。",
  },
];

export const categories = [
  {
    icon: "ri-briefcase-4-line",
    title: "职场与用工乱象",
    desc: "拖欠薪资、违规加班、劳动合同问题、违规用工等。",
    count: "1,240+ 条",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "消费与合同纠纷",
    desc: "虚假宣传、霸王条款、预付费跑路、售后推诿等。",
    count: "980+ 条",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "公共安全与隐患",
    desc: "设施隐患、违规作业、消防风险、食品药品安全等。",
    count: "760+ 条",
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "财务与商业道德",
    desc: "财务造假、回扣利益输送、招标围标、资金挪用等。",
    count: "610+ 条",
  },
  {
    icon: "ri-plant-line",
    title: "环境与资源问题",
    desc: "违规排污、超标排放、资源破坏、环评造假等。",
    count: "420+ 条",
  },
  {
    icon: "ri-government-line",
    title: "公共服务与流程",
    desc: "办事流程不合理、服务态度、信息公开不到位等。",
    count: "350+ 条",
  },
];

export const stats = [
  { value: "51", label: "条保密处理通道", suffix: "" },
  { value: "24", label: "小时接收投稿", suffix: "h" },
  { value: "0", label: "强制实名要求", suffix: "" },
  { value: "3", label: "个工作日反馈", suffix: "天" },
];

export const promises = [
  "不要求提供真实姓名、身份证件或工作证明",
  "不在公开渠道展示可定位到个人的原始材料",
  "不把投稿内容用于传播之外的商业用途",
  "收到删除请求时，按流程清理对应内容",
];